import { render, staticRenderFns } from "./CensimentoProdotti.vue?vue&type=template&id=30619d06&scoped=true&"
import script from "./CensimentoProdotti.vue?vue&type=script&lang=ts&"
export * from "./CensimentoProdotti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30619d06",
  null
  
)

export default component.exports